import React from "react";
import {
  Typography,
  Badge,
  ToggleButtonGroup,
  ToggleButton,
  Tooltip,
  IconButton,
  Button,
} from "@mui/material";
import {
  DateRange as DateRangeIcon,
  FilterList as FilterListIcon,
  TableChart as TableChartIcon,
  CalendarMonth as CalendarMonthIcon,
  HelpOutline as HelpOutlineIcon,
} from "@mui/icons-material";
import {
  ToolbarContainer,
  ToolbarLeft,
  ToolbarRight,
  DateRangeDisplay,
  ToolbarIconButton,
} from "./styles";

function Toolbar({
  selectedItemCount,
  dateRange,
  viewMode,
  isItemPanelOpen,
  onToggleDatePanel,
  onToggleItemPanel,
  onViewModeChange,
}) {
  return (
    <ToolbarContainer>
      <ToolbarLeft>
        <Typography
          variant="h5"
          fontWeight={700}
          sx={{ fontSize: "22px !important", color: "#111" }}
        >
          생산계획표
        </Typography>
      </ToolbarLeft>
      <ToolbarRight>
        <DateRangeDisplay
          onClick={onToggleDatePanel}
          className="date-panel-toggle"
        >
          <DateRangeIcon fontSize="small" />
          <Typography variant="body2" fontWeight={500} sx={{ color: "white" }}>
            {dateRange.start.format("YYYY/MM/DD")} ~{" "}
            {dateRange.end.format("YYYY/MM/DD")}
          </Typography>
        </DateRangeDisplay>
        <Badge
          badgeContent={selectedItemCount}
          color="primary"
          overlap="circular"
        >
          <Button
            onClick={onToggleItemPanel}
            title="아이템 선택"
            variant="contained"
            color="primary"
            startIcon={<FilterListIcon />}
            sx={{ minWidth: 90, height: 32, fontSize: '1rem' }}
            className="item-panel-toggle"
          >
            품명 선택
          </Button>
        </Badge>
        {/* <ToggleButtonGroup
          value={viewMode}
          exclusive
          onChange={onViewModeChange}
          size="small"
          sx={{ mx: 1 }}
        >
          <ToggleButton value="table" aria-label="표 보기">
            <TableChartIcon fontSize="small" />
          </ToggleButton>
          <ToggleButton value="calendar" aria-label="달력 보기">
            <CalendarMonthIcon fontSize="small" />
          </ToggleButton>
        </ToggleButtonGroup> */}
        {/* <Tooltip title="도움말">
          <IconButton size="small">
            <HelpOutlineIcon fontSize="small" />
          </IconButton>
        </Tooltip> */}
      </ToolbarRight>
    </ToolbarContainer>
  );
}

export default Toolbar;
